import { makeStyles } from '@material-ui/core/styles';
import { DataRow } from 'app/components';
import clsx from 'clsx';
import React, { useState, useMemo } from 'react';
import TitleField from '../TitleField';
import { Card, Typography, Chip, Table, TableBody, TableRow, TableCell, Grid, Box, Tabs, Tab, Divider } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },

  imageContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },

  image: {
    maxWidth: '100%',
    maxHeight: 400,
    borderRadius: 8,
    border: '1px solid #ddd',
  },

  tabs: {
    marginTop: theme.spacing(1),
  },
  section: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: 10,
    border: '1px solid #eee',
    background: '#fafafa',
  },

  row: {
    padding: `${theme.spacing(1.5)}px 0`,
  },

  label: {
    fontWeight: 500,
    color: '#666',
    fontSize: 13,
  },

  value: {
    fontWeight: 600,
    color: '#222',
    fontSize: 14,
    textAlign: 'right',
  },

  successChip: {
    backgroundColor: '#e6f4ea',
    color: '#1e7e34',
    fontWeight: 600,
  },

  failChip: {
    backgroundColor: '#fdecea',
    color: '#c62828',
    fontWeight: 600,
  },
}));

// 🔥 Format extracted fields (IMPORTANT)
const formatFieldValue = (fieldType, value) => {
  if (!value) return '-';

  switch (fieldType) {
    case 'Date of birth':
    case 'Date of issue': {
      const parsed = new Date(value);
      return isNaN(parsed.getTime())
        ? value
        : parsed.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          });
    }

    case 'Sex': {
      const g = value.toString().toUpperCase();
      if (g === 'M') return 'Male';
      if (g === 'F') return 'Female';
      return value;
    }

    case 'Address':
      return value.split('\n').map((line, i) => <div key={i}>{line}</div>);

    default:
      return value;
  }
};

const RegtankDocumentTable = ({ documents = {}, className }) => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const docInfo = documents?.documentInfo || {};
  const ocr = documents?.ocrResults || {};
  const idvV1Info = documents?.idvV1Info || {};
  const docCategories = idvV1Info?.ocrV2Info?.documentCategories || [];
  const docTypes = idvV1Info?.ocrV2Info?.documentTypes || [];
  const extensions = idvV1Info?.documentExtensions || [];
  const fields = idvV1Info?.ocrV2Info?.documentFields || [];

  const renderStatus = () => {
    if (ocr.status === 'SUCCESS') {
      return <Chip label="SUCCESS" size="small" className={classes.successChip} />;
    }

    if (!ocr.status) return '-';

    return <Chip label={ocr.status} size="small" className={classes.failChip} />;
  };
  // 🔥 Tabs
  const tabs = [
    { label: 'Front', value: docInfo.frontDocumentUrl },
    { label: 'Back', value: docInfo.backDocumentUrl },

    ...extensions
      .filter((ext) => ['Portrait', 'Barcode', 'Fingerprint', 'Ghost portrait'].includes(ext.key))
      .map((ext) => ({
        label: ext.key,
        value: ext.value,
      })),
  ].filter((t) => t.value);

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>ID Photo</TitleField>

      {/* 🔥 Tabs */}
      <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} indicatorColor="primary" textColor="primary" variant="scrollable" scrollButtons="auto" className={classes.tabs}>
        {tabs.map((t, i) => (
          <Tab key={i} label={t.label} />
        ))}
      </Tabs>

      {/* 🔥 Image Viewer */}
      <Box className={classes.imageContainer}>{tabs[tab]?.value && <img src={tabs[tab].value} alt={tabs[tab].label} className={classes.image} />}</Box>

      <Box className={classes.section}>
        <Table size="small">
          <TableBody>
            {/* Document Type */}
            <TableRow>
              <TableCell style={{ fontWeight: 600, width: '30%', color: '#666' }}>Document Type</TableCell>
              <TableCell>{[...new Set(docTypes)].length ? [...new Set(docTypes)].map((t, i) => <div key={i}>{t}</div>) : '-'}</TableCell>
            </TableRow>

            {/* Document Category */}
            <TableRow>
              <TableCell style={{ fontWeight: 600, color: '#666' }}>Document Category</TableCell>
              <TableCell>{[...new Set(docCategories)].length ? [...new Set(docCategories)].map((c, i) => <div key={i}>{c}</div>) : '-'}</TableCell>
            </TableRow>

            {/* OCR Status */}
            <TableRow>
              <TableCell style={{ fontWeight: 600, color: '#666' }}>OCR Status</TableCell>
              <TableCell>{renderStatus()}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>

      {/* 🔥 ALL Extracted Fields (FIXED HERE) */}
      {fields.length > 0 && (
        <>
          <Divider style={{ margin: '16px 0' }} />

          <Table>
            <TableBody>
              {fields.map((f, i) => (
                <DataRow key={i} name={f.fieldType} value={formatFieldValue(f.fieldType, f.visualZone)} />
              ))}
            </TableBody>
          </Table>
        </>
      )}
    </Card>
  );
};

export default RegtankDocumentTable;
